import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/Layout'
// import Admin from '@/views/Admin'
import MainRoutes from './mainRoutes'
import AdminRoutes from './adminRoutes'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Root',
    component: Layout,
    redirect: { name: 'About' },
    children: MainRoutes
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/Admin'),
    redirect: { name: 'AdminHome' },
    meta: {
      title: '嗨支付-后台',
      auth: true
    },
    children: AdminRoutes
  },
  {
    path: '/signin',
    name: 'Signin',
    component: () => import('../views/Admin/Signin'),
    meta: {
      auth: false,
      title: '嗨支付-后台登入'
      },
    hidden: true
  }
]

const router = new VueRouter({
  routes,
  linkActiveClass: 'active'
})

export default router
